export default __webpack_public_path__ + "static/media/ToyotaType-Light.d4fde169.ttf";